module.exports = __webpack_public_path__ + "img/banner_iv3.2ed8e2b9.png";